import React from 'react';
import useRTL from 'src/hooks/useRTL';
import { withTranslation } from 'react-i18next';
import FiberManualRecord from '@mui/icons-material/FiberManualRecord';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({  
    tagMainDiv:{
      display:'flex',
      flexDirection:'row',
      alignItems:'center',
      backgroundColor:'#154369',
      position:'absolute',
      right: '37px',
      top: '10px',
      padding: '8px 3px',
      borderRadius: '8px',
      width:'auto !important',
      height:'auto !important',
      '& svg':{
        fontSize: '0.8rem',
        padding: '0px 5px',
      },
  
      '& span':{
        fontSize: '0.9rem',
        padding: '0px 5px',
      }
    }
}));

const OnlineTag = ({online,color,bgColor,...props}) =>{
    const classes = useStyles();
    const [, , fontFamily] = useRTL();
    const { t } = props;
    return(
      <div className={classes.tagMainDiv} style={{fontFamily:'inherit',color:color,backgroundColor:bgColor}}>
        <FiberManualRecord />
        <span style={{fontFamily:'inherit'}}>{online ? t && t('companyPage.online') : t && t('companyPage.offline')}</span>
      </div>
    )
};

export default withTranslation('common')(OnlineTag);